<div class="sir-container" data-cy="badge">
    @if (size !== BadgeSize.XS) {
        {{ count }}
    }
</div>
